import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Helper } from "../../providers/helper";
import { AuthService } from "../../services/auth.service";
import { SessionService } from "../session.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WarningModalComponent } from "../../modals/warning-modal/warning-modal.component";

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private helper: Helper,
        private auth: AuthService,
        private sessionService: SessionService,
        private modalService: NgbModal,
        public activeModal: NgbActiveModal
    ) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        let userdata = this.sessionService.currentUser;
        if (!userdata) {
            if (localStorage.getItem("token")) {
                return new Promise<boolean>((resolve, reject) => {
                    return this.auth
                        .get_current_user_by_token(localStorage.getItem("token"))
                        .then((res) => {
                            if (res) {
                                if (!Array.isArray(route.data.role)) {
                                    console.error("no role specified for route");
                                    this.showAlert();
                                    // this.sessionService.clearLocalStorageAndSession();
                                    // this.router.navigate(["login"]);
                                    resolve(false);
                                } else {
                                    resolve(route.data.role.includes(this.sessionService.currentUserRole));
                                }
                            } else {
                                this.sessionService.clearLocalStorageAndSession();
                                this.router.navigate(["login"]);
                                resolve(false);
                            }
                        })
                        .catch((ex) => {
                            this.showAlert();
                            // this.sessionService.clearLocalStorageAndSession();
                            // this.router.navigate(["login"]);
                            resolve(false);
                        });
                });
            } else {
                this.sessionService.clearLocalStorageAndSession();
                this.router.navigate(["login"]);
                return Promise.resolve(false);
            }
        } else {
            // if (userdata.attributes.roles.some((item) => environment.allow_roles.includes(item))) {
            if (Array.isArray(route.data.dashboadrmodule)) {
                if (this.sessionService.currentUser.attributes.msxInfo.dashboardModules.includes(route.data.dashboadrmodule[0])) {
                    return Promise.resolve(true);
                } else {
                    this.sessionService.clearLocalStorageAndSession();
                    this.router.navigate(["login"]);
                    return Promise.resolve(false);
                }
            }

            // Clean-key `data: { module: '<claim>' }` gate. Additive to the
            // existing `dashboadrmodule` (typo'd) shape so existing routes
            // keep working unchanged. Introduced 2026-05-27 for the
            // Evidence.dev pilot route (ClioAdmin #68 Stage 2). Reads the
            // `dashboardModules` claim minted by clio-server's
            // /user/msxlogin into the JWT — see audit doc §3.7.
            if (typeof route.data.module === "string") {
                const dashboardModules = this.sessionService.currentUser?.attributes?.msxInfo?.dashboardModules;
                const moduleAllowed = Array.isArray(dashboardModules) && dashboardModules.includes(route.data.module);
                if (!moduleAllowed) {
                    // #71: The user IS authenticated (we're in the `userdata` present
                    // branch) — they just lack this specific module entitlement (e.g.
                    // 'classicReports'). Soft-redirect to /home instead of clearing the
                    // session and bouncing to login: missing a feature claim is not an
                    // auth failure. Only the unauthenticated / no-token path (top of
                    // canActivate) and the legacy `dashboadrmodule` branch still log out.
                    this.router.navigate(["/home"]);
                    return Promise.resolve(false);
                }
                // Module claim passes; fall through to the role check below so
                // both gates apply when a route declares both.
            }

            if (!Array.isArray(route.data.role)) {
                // console.error("no role specified for route");
                // this.sessionService.clearLocalStorageAndSession();
                // this.router.navigate(["login"]);
                this.showAlert();
                return Promise.resolve(false);
            } else {
                return Promise.resolve(route.data.role.includes(this.sessionService.currentUserRole));
            }
        }
    }

    public showAlert() {
        const modalRef = this.modalService.open(WarningModalComponent, { backdrop: "static" });
        modalRef.componentInstance.Message = "We detected an unauthorized access attempt, Please contact support@medstatix.com with any questions. ";
        modalRef.componentInstance.OKButton = "Ok";
        modalRef.componentInstance.Type = "alert";
        modalRef.componentInstance.Response.subscribe((receivedEntry) => {
            if (receivedEntry.proceed) {
                this.activeModal.close();
            }
        });
    }
}
